import { ActionIcon, CopyButton, Group, Stack, TextInput, Tooltip } from '@mantine/core';
import { QRCode } from './QRCode';
import { IconCheck, IconCopy, IconExternalLink } from '@tabler/icons-react';

export const ServiceLink = ({ url, churchName }: { url: string; churchName: string }) => {
  return (
    <Stack gap="md">
      <TextInput
        value={url}
        readOnly
        aria-label="Listener link"
        onFocus={(event) => event.currentTarget.select()}
        rightSectionWidth={72}
        rightSection={
          <Group gap={2} wrap="nowrap">
            <CopyButton value={url || ''} timeout={1500}>
              {({ copied, copy }) => (
                <Tooltip label={copied ? 'Copied' : 'Copy link'} withArrow>
                  <ActionIcon
                    variant="subtle"
                    color={copied ? 'teal' : 'gray'}
                    onClick={copy}
                    aria-label="Copy link"
                  >
                    {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                  </ActionIcon>
                </Tooltip>
              )}
            </CopyButton>
            <Tooltip label="Open listener page" withArrow>
              <ActionIcon
                variant="subtle"
                color="gray"
                onClick={() => window.open(url, '_blank')}
                aria-label="Open listener page"
              >
                <IconExternalLink size={16} />
              </ActionIcon>
            </Tooltip>
          </Group>
        }
      />

      <QRCode name={churchName} data={url} />
    </Stack>
  );
};
